module.exports = __webpack_public_path__ + "img/background.b0ae3c4.webp";